export const systemIconValues = ['action-required', 'actionRequired', 'add', 'add-column-left', 'add-column-right', 'add-logic', 'add-row-above', 'add-row-below', 'addColumnLeft', 'addColumnRight', 'addLogic', 'addRowAbove', 'addRowBelow', 'alert', 'alert-triangle', 'alertTriangle', 'align-bottom', 'align-left', 'align-right', 'align-top', 'alignBottom', 'alignLeft', 'alignRight', 'alignTop', 'approve', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrow-up-left', 'arrowDown', 'arrowLeft', 'arrowRight', 'arrowUp', 'arrowUpLeft', 'at', 'attachment', 'authentication', 'auto-fill', 'autoFill', 'award', 'bell', 'block', 'bold', 'book', 'book-open', 'bookOpen', 'boolean', 'box-plus-above', 'box-plus-after', 'box-plus-before', 'box-plus-below', 'boxPlusAbove', 'boxPlusAfter', 'boxPlusBefore', 'boxPlusBelow', 'brightness', 'browser-stack', 'browserStack', 'bulk-send', 'bulkSend', 'bulleted-list', 'bulletedList', 'calendar', 'camera', 'caret-down', 'caret-large-down', 'caret-large-left', 'caret-large-right', 'caret-large-up', 'caret-left', 'caret-right', 'caret-up', 'caret-xlarge-down', 'caret-xlarge-left', 'caret-xlarge-right', 'caret-xlarge-up', 'caretDown', 'caretLargeDown', 'caretLargeLeft', 'caretLargeRight', 'caretLargeUp', 'caretLeft', 'caretRight', 'caretUp', 'caretXlargeDown', 'caretXlargeLeft', 'caretXlargeRight', 'caretXlargeUp', 'certificate', 'chat', 'check', 'checkbox', 'checkmark', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'chevronDown', 'chevronLeft', 'chevronRight', 'chevronUp', 'circle-check', 'circle-status', 'circle-status-closed', 'circle-x', 'circleCheck', 'circleStatus', 'circleStatusClosed', 'circleX', 'clipboard', 'clock', 'close', 'close-small', 'close-xlarge', 'closeSmall', 'closeXlarge', 'cloud-upload', 'cloudUpload', 'cluster', 'code-bracket', 'codeBracket', 'collapse', 'collapse-section', 'collapseSection', 'color-filter', 'colorFilter', 'colorpicker', 'column', 'comment', 'comment-add', 'comment-pencil', 'commentAdd', 'commentPencil', 'commission-county', 'commission-number', 'commissionCounty', 'commissionNumber', 'company', 'completed', 'computer', 'contacts', 'copy', 'courthouse', 'credit-card', 'creditCard', 'crop', 'currency', 'data-read', 'data-read-write', 'dataRead', 'dataReadWrite', 'database', 'date', 'decline', 'desktop', 'desktop-share', 'desktopShare', 'detail-view', 'detailView', 'devices', 'diamond-stack', 'diamondStack', 'document', 'document-pencil', 'document-stack', 'documentPencil', 'documentStack', 'documents', 'download', 'draft', 'dropdown', 'duplicate', 'edit', 'email', 'enter', 'envelope', 'expanded-list', 'expandedList', 'export', 'expression', 'external-link', 'externalLink', 'eye', 'eye-slash', 'eyeSlash', 'eyedropper', 'field', 'field-merge', 'fieldMerge', 'fields-custom', 'fields-merge', 'fields-standard', 'fieldsCustom', 'fieldsMerge', 'fieldsStandard', 'filter', 'flag', 'flash', 'flash-off', 'flashOff', 'focus-button', 'focusButton', 'folder', 'folder-open', 'folderOpen', 'follower-database', 'followerDatabase', 'formula', 'function', 'function-folder', 'functionFolder', 'gear', 'globe', 'globe-language', 'globeLanguage', 'grid-view', 'gridView', 'gripper-bar', 'gripper-corner', 'gripper-rectangle', 'gripper-rectangle-horizontal', 'gripperBar', 'gripperCorner', 'gripperRectangle', 'gripperRectangleHorizontal', 'hanko', 'hash', 'heading', 'heart-plus', 'heartPlus', 'help', 'hide', 'hierarchy', 'highlighter', 'history', 'home', 'id-badge', 'id-card', 'idBadge', 'idCard', 'identity-verification', 'identityVerification', 'image', 'inbox', 'indicator-current', 'indicator-incomplete', 'indicatorCurrent', 'indicatorIncomplete', 'info', 'initials', 'insert', 'italic', 'italics', 'keyboard', 'language', 'line', 'line-height', 'lineHeight', 'link', 'list', 'location', 'location-pin', 'locationPin', 'lock', 'logic', 'mail', 'menu', 'menu-hamburger', 'menu-overflow-horizontal', 'menu-overflow-vertical', 'menu-triangle-down', 'menu-triangle-left', 'menu-triangle-right', 'menu-triangle-up', 'menu-waffle', 'menuHamburger', 'menuOverflowHorizontal', 'menuOverflowVertical', 'menuTriangleDown', 'menuTriangleLeft', 'menuTriangleRight', 'menuTriangleUp', 'menuWaffle', 'merge-cell', 'merge-fields-dynamic', 'mergeCell', 'mergeFieldsDynamic', 'messages', 'microphone', 'microphone-off', 'microphoneOff', 'minus', 'mobile-phone', 'mobilePhone', 'move-cursor', 'moveCursor', 'multi-arrow', 'multiArrow', 'name', 'name-first', 'name-last', 'nameFirst', 'nameLast', 'notary', 'note', 'notification', 'number', 'number-global', 'number-list', 'numberGlobal', 'numberList', 'numbered-list', 'numberedList', 'overflow-horizontal', 'overflow-vertical', 'overflowHorizontal', 'overflowVertical', 'page-break', 'pageBreak', 'paint-brush-line', 'paint-bucket', 'paint-palette', 'paint-roller', 'paintBrushLine', 'paintBucket', 'paintPalette', 'paintRoller', 'palette', 'paperclip', 'paste', 'pause', 'payment', 'pebble-check', 'pebble-error', 'pebble-info', 'pebble-question', 'pebble-warning', 'pebbleCheck', 'pebbleError', 'pebbleInfo', 'pebbleQuestion', 'pebbleWarning', 'pencil', 'people', 'percent', 'person', 'person-plus', 'person-scan', 'personPlus', 'personScan', 'phone', 'phone-mobile', 'phoneMobile', 'play', 'plugin', 'plus', 'powerform', 'print', 'printer', 'process-spinner', 'processSpinner', 'radar', 'radio', 'read-data', 'read-write-data', 'readData', 'readWriteData', 'receives-copy', 'receivesCopy', 'recipient-add', 'recipient-update', 'recipientAdd', 'recipientUpdate', 'redo', 'refresh', 'reports', 'rotate-left', 'rotate-right', 'rotateLeft', 'rotateRight', 'scan', 'seal-notary', 'sealNotary', 'search', 'select', 'select-signature-type', 'selectSignatureType', 'send', 'sent', 'settings', 'share-android', 'share-i-os', 'share-ios', 'share-web', 'shareAndroid', 'shareIos', 'shareWeb', 'share_iOS', 'shared', 'shield', 'shield-cfr-part11', 'shield-check', 'shieldCfrPart11', 'shieldCheck', 'sign', 'sign-in-person', 'sign-with-witness', 'signInPerson', 'signWithWitness', 'signature', 'smart-clause', 'smart-sections', 'smart-tag', 'smartClause', 'smartSections', 'smartTag', 'sort', 'spark', 'sparkles', 'speedometer', 'squiggle', 'stamp', 'star', 'star-filled', 'starFilled', 'state', 'stop', 'strikethrough', 'suggest', 'suggested', 'support', 'support-contact', 'supportContact', 'swatch', 'sync', 'table', 'table-alt', 'table-border-off', 'table-folder', 'tableAlt', 'tableBorderOff', 'tableFolder', 'tablet', 'tag', 'task-list', 'taskList', 'template-view', 'templateView', 'templates', 'text', 'text-align-center', 'text-align-left', 'text-align-right', 'text-block', 'text-center', 'text-color', 'text-indent-left', 'text-indent-right', 'text-justify', 'text-justify-center', 'text-left', 'text-long', 'text-right', 'text-short', 'textAlignCenter', 'textAlignLeft', 'textAlignRight', 'textBlock', 'textCenter', 'textColor', 'textIndentLeft', 'textIndentRight', 'textJustify', 'textJustifyCenter', 'textLeft', 'textLong', 'textRight', 'textShort', 'thumbnails', 'thumbs-down', 'thumbs-down-filled', 'thumbs-up', 'thumbs-up-filled', 'thumbsDown', 'thumbsDownFilled', 'thumbsUp', 'thumbsUpFilled', 'title', 'transactions', 'trash', 'trust-center', 'trust-center-check', 'trustCenter', 'trustCenterCheck', 'type-image', 'typeImage', 'underline', 'undo', 'unlock', 'unmerge-cell', 'unmergeCell', 'upload', 'upload-cloud', 'upload-list', 'uploadCloud', 'uploadList', 'user', 'video-camera', 'video-camera-off', 'videoCamera', 'videoCameraOff', 'view', 'voided', 'waffle', 'waiting-for-others', 'waitingForOthers', 'wallet', 'wifi', 'workflow', 'wrench', 'zoom-in', 'zoom-out', 'zoomIn', 'zoomOut'];
export const systemIconMap = {
  "action-required": "actionRequired",
  "add-logic": "addLogic",
  "align-bottom": "alignBottom",
  "align-left": "alignLeft",
  "align-right": "alignRight",
  "align-top": "alignTop",
  "arrow-down": "arrowDown",
  "arrow-left": "arrowLeft",
  "arrow-right": "arrowRight",
  "arrow-up": "arrowUp",
  "arrow-up-left": "arrowUpLeft",
  "auto-fill": "autoFill",
  "sealNotary": "award",
  "seal-notary": "award",
  "notification": "bell",
  "voided": "block",
  "book-open": "bookOpen",
  "box-plus-above": "boxPlusAbove",
  "addRowAbove": "boxPlusAbove",
  "add-row-above": "boxPlusAbove",
  "box-plus-after": "boxPlusAfter",
  "addColumnRight": "boxPlusAfter",
  "add-column-right": "boxPlusAfter",
  "box-plus-before": "boxPlusBefore",
  "addColumnLeft": "boxPlusBefore",
  "add-column-left": "boxPlusBefore",
  "box-plus-below": "boxPlusBelow",
  "addRowBelow": "boxPlusBelow",
  "add-row-below": "boxPlusBelow",
  "browser-stack": "browserStack",
  "bulk-send": "bulkSend",
  "bulleted-list": "bulletedList",
  "list": "bulletedList",
  "date": "calendar",
  "caret-large-down": "caretLargeDown",
  "caret-large-left": "caretLargeLeft",
  "caret-large-right": "caretLargeRight",
  "caret-large-up": "caretLargeUp",
  "caret-xlarge-down": "caretXlargeDown",
  "caret-xlarge-left": "caretXlargeLeft",
  "caret-xlarge-right": "caretXlargeRight",
  "caret-xlarge-up": "caretXlargeUp",
  "completed": "check",
  "chevron-down": "chevronDown",
  "caretDown": "chevronDown",
  "caret-down": "chevronDown",
  "chevron-left": "chevronLeft",
  "caretLeft": "chevronLeft",
  "caret-left": "chevronLeft",
  "chevron-right": "chevronRight",
  "caretRight": "chevronRight",
  "caret-right": "chevronRight",
  "chevron-up": "chevronUp",
  "caretUp": "chevronUp",
  "caret-up": "chevronUp",
  "circle-status": "circleStatus",
  "circle-status-closed": "circleStatusClosed",
  "circle-x": "circleX",
  "paste": "clipboard",
  "waitingForOthers": "clock",
  "waiting-for-others": "clock",
  "close-small": "closeSmall",
  "close-xlarge": "closeXlarge",
  "cloud-upload": "cloudUpload",
  "uploadCloud": "cloudUpload",
  "upload-cloud": "cloudUpload",
  "code-bracket": "codeBracket",
  "collapse-section": "collapseSection",
  "color-filter": "colorFilter",
  "comment-add": "commentAdd",
  "comment-pencil": "commentPencil",
  "commissionCounty": "courthouse",
  "commission-county": "courthouse",
  "credit-card": "creditCard",
  "data-read": "dataRead",
  "readData": "dataRead",
  "read-data": "dataRead",
  "data-read-write": "dataReadWrite",
  "readWriteData": "dataReadWrite",
  "read-write-data": "dataReadWrite",
  "computer": "desktop",
  "desktop-share": "desktopShare",
  "detail-view": "detailView",
  "expandedList": "detailView",
  "expanded-list": "detailView",
  "diamond-stack": "diamondStack",
  "documents": "document",
  "document-pencil": "documentPencil",
  "document-stack": "documentStack",
  "copy": "duplicate",
  "email": "envelope",
  "mail": "envelope",
  "external-link": "externalLink",
  "view": "eye",
  "eye-slash": "eyeSlash",
  "hide": "eyeSlash",
  "colorpicker": "eyedropper",
  "fieldsStandard": "field",
  "fields-standard": "field",
  "field-merge": "fieldMerge",
  "fieldsMerge": "fieldMerge",
  "fields-merge": "fieldMerge",
  "fields-custom": "fieldsCustom",
  "state": "flag",
  "flash-off": "flashOff",
  "focus-button": "focusButton",
  "folder-open": "folderOpen",
  "follower-database": "followerDatabase",
  "function": "formula",
  "function-folder": "functionFolder",
  "settings": "gear",
  "globe-language": "globeLanguage",
  "globe": "globeLanguage",
  "language": "globeLanguage",
  "grid-view": "gridView",
  "gripper-bar": "gripperBar",
  "gripperRectangle": "gripperBar",
  "gripper-rectangle": "gripperBar",
  "gripper-corner": "gripperCorner",
  "gripper-rectangle-horizontal": "gripperRectangleHorizontal",
  "heart-plus": "heartPlus",
  "id-badge": "idBadge",
  "idCard": "idBadge",
  "id-card": "idBadge",
  "identity-verification": "identityVerification",
  "typeImage": "image",
  "type-image": "image",
  "indicator-current": "indicatorCurrent",
  "indicator-incomplete": "indicatorIncomplete",
  "enter": "insert",
  "italic": "italics",
  "line-height": "lineHeight",
  "location-pin": "locationPin",
  "location": "locationPin",
  "menuHamburger": "menu",
  "menu-hamburger": "menu",
  "menu-triangle-down": "menuTriangleDown",
  "menu-triangle-left": "menuTriangleLeft",
  "menu-triangle-right": "menuTriangleRight",
  "menu-triangle-up": "menuTriangleUp",
  "merge-cell": "mergeCell",
  "merge-fields-dynamic": "mergeFieldsDynamic",
  "chat": "messages",
  "microphone-off": "microphoneOff",
  "mobile-phone": "mobilePhone",
  "phoneMobile": "mobilePhone",
  "phone-mobile": "mobilePhone",
  "multi-arrow": "multiArrow",
  "moveCursor": "multiArrow",
  "move-cursor": "multiArrow",
  "name-first": "nameFirst",
  "name-last": "nameLast",
  "commissionNumber": "number",
  "commission-number": "number",
  "hash": "number",
  "number-global": "numberGlobal",
  "numbered-list": "numberedList",
  "numberList": "numberedList",
  "number-list": "numberedList",
  "overflow-horizontal": "overflowHorizontal",
  "menuOverflowHorizontal": "overflowHorizontal",
  "menu-overflow-horizontal": "overflowHorizontal",
  "overflow-vertical": "overflowVertical",
  "menuOverflowVertical": "overflowVertical",
  "menu-overflow-vertical": "overflowVertical",
  "page-break": "pageBreak",
  "paint-brush-line": "paintBrushLine",
  "paint-bucket": "paintBucket",
  "paint-palette": "paintPalette",
  "palette": "paintPalette",
  "paint-roller": "paintRoller",
  "attachment": "paperclip",
  "pebble-check": "pebbleCheck",
  "circleCheck": "pebbleCheck",
  "circle-check": "pebbleCheck",
  "pebble-error": "pebbleError",
  "pebble-info": "pebbleInfo",
  "info": "pebbleInfo",
  "pebble-question": "pebbleQuestion",
  "help": "pebbleQuestion",
  "pebble-warning": "pebbleWarning",
  "alert": "pebbleWarning",
  "alertTriangle": "pebbleWarning",
  "alert-triangle": "pebbleWarning",
  "edit": "pencil",
  "shared": "people",
  "name": "person",
  "user": "person",
  "person-plus": "personPlus",
  "recipientAdd": "personPlus",
  "recipient-add": "personPlus",
  "person-scan": "personScan",
  "add": "plus",
  "print": "printer",
  "process-spinner": "processSpinner",
  "receives-copy": "receivesCopy",
  "recipient-update": "recipientUpdate",
  "sync": "refresh",
  "rotate-left": "rotateLeft",
  "rotate-right": "rotateRight",
  "dropdown": "select",
  "select-signature-type": "selectSignatureType",
  "sent": "send",
  "share-android": "shareAndroid",
  "share-ios": "shareIos",
  "share_iOS": "shareIos",
  "share-i-os": "shareIos",
  "share-web": "shareWeb",
  "trustCenter": "shield",
  "trust-center": "shield",
  "shield-cfr-part11": "shieldCfrPart11",
  "shield-check": "shieldCheck",
  "trustCenterCheck": "shieldCheck",
  "trust-center-check": "shieldCheck",
  "signature": "sign",
  "sign-in-person": "signInPerson",
  "sign-with-witness": "signWithWitness",
  "smart-clause": "smartClause",
  "smart-sections": "smartSections",
  "smart-tag": "smartTag",
  "star-filled": "starFilled",
  "supportContact": "support",
  "support-contact": "support",
  "table-alt": "tableAlt",
  "table-border-off": "tableBorderOff",
  "table-folder": "tableFolder",
  "task-list": "taskList",
  "template-view": "templateView",
  "text-align-center": "textAlignCenter",
  "textCenter": "textAlignCenter",
  "text-center": "textAlignCenter",
  "text-align-left": "textAlignLeft",
  "textLeft": "textAlignLeft",
  "text-left": "textAlignLeft",
  "text-align-right": "textAlignRight",
  "textRight": "textAlignRight",
  "text-right": "textAlignRight",
  "text-block": "textBlock",
  "text-color": "textColor",
  "text-indent-left": "textIndentLeft",
  "text-indent-right": "textIndentRight",
  "text-justify-center": "textJustifyCenter",
  "textJustify": "textJustifyCenter",
  "text-justify": "textJustifyCenter",
  "text-long": "textLong",
  "text-short": "textShort",
  "thumbs-down": "thumbsDown",
  "thumbs-down-filled": "thumbsDownFilled",
  "thumbs-up": "thumbsUp",
  "thumbs-up-filled": "thumbsUpFilled",
  "unmerge-cell": "unmergeCell",
  "upload-list": "uploadList",
  "video-camera": "videoCamera",
  "video-camera-off": "videoCameraOff",
  "menuWaffle": "waffle",
  "menu-waffle": "waffle",
  "payment": "wallet",
  "zoom-in": "zoomIn",
  "zoom-out": "zoomOut"
};